import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { AppProvider } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import SiteGate from "./components/SiteGate";
import Home from "./pages/Home";
import About from "./pages/About";
import FieldFaces from "./pages/FieldFaces";
import Artwork from "./pages/Artwork";
import ArtworkDetail from "./pages/ArtworkDetail";
import Exhibitions from "./pages/Exhibitions";
import Rise from "./pages/Rise";
import Collection from "./pages/Collection";
import Datos from "./pages/Datos";
import Collect from "./pages/Collect";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Admin from "./pages/AdminDashboard";
import PaymentResult from "./pages/PaymentResult";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return null;
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollTop />
        <div className="min-h-screen bg-background text-foreground" data-testid="app-shell">
          <Navbar />
          <CartDrawer />
          <SiteGate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/field-faces" element={<FieldFaces />} />
              <Route path="/artwork" element={<Artwork />} />
              <Route path="/artwork/:id" element={<ArtworkDetail />} />
              <Route path="/exhibitions" element={<Exhibitions />} />
              <Route path="/rise" element={<Rise />} />
              <Route path="/the-collection" element={<Collection />} />
              <Route path="/datos" element={<Datos />} />
              <Route path="/collect" element={<Collect />} />
              <Route path="/news" element={<News />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/:result" element={<PaymentResult />} />
            </Routes>
          </SiteGate>
          <Footer />
        </div>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#0D0D0D", color: "#F5F5F5", border: "1px solid #2A2A2A", borderRadius: 0 } }} />
      </BrowserRouter>
    </AppProvider>
  );
}
